import {createAsyncThunk} from '@reduxjs/toolkit';

export const getPlansForPricingDialog = createAsyncThunk('getPlansForPricingDialog', async () => {
  return window.PMW.readLocal('premium/getPlansForPricingDialog');
});
